export const typeOfServicesData  = ['Adults with learning difficulties',
          'Children with learning difficulties',
          'Service users with dementia',
          'Service users with mental health',
          'Service users with dual diagnosis',
          'EMI (elderly service users with mental health)',
          'Service users that may require restraint',
          'Are you able to swim with service users'
        ]